import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { MarketLink, MarketTooltip } from '@market/react';
import { ADJUSTMENT_TYPE_MAPPINGS } from 'constants/mappings';
import ReceiptItem from 'components/common/receipt/receipt_item';
import { onCartPageClick } from 'components/pages/cart/utilities';

const ActionablePromotion = ({
  disabled = false,
  code,
  adjustments = [],
  currency,
  canRemove = true,
  onRemove,
  didReachCartLimit = false,
}) => {
  const { t } = useTranslation();

  const adjustmentItems = adjustments.map((adjustment, index) => (
    <ReceiptItem
      key={`adjustment-${index}`}
      label={ADJUSTMENT_TYPE_MAPPINGS[adjustment.type]}
      cost={adjustment.amount}
      currency={currency}
      negativeZero={true}
      leftOffset={3}
    />
  ));

  return (
    <>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <p className="paragraph-20">
            {t('checkout.receipt.label.promotion', { code })}
            {didReachCartLimit && (
              <MarketTooltip
                popover-placement="bottom-end"
                style={{
                  verticalAlign: 'middle',
                }}
              >
                <span slot="content">
                  {t('checkout.receipt.label.maximumPromoDiscountApplied')}
                </span>
              </MarketTooltip>
            )}
          </p>
        </Grid>
        <Grid item>
          {canRemove && (
            <MarketLink
              {...(disabled && { disabled: true })}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onRemove(code);
                onCartPageClick({
                  actionItem: 'remove_promo_code',
                  additionalParameters: {
                    code,
                  },
                });
              }}
              className="medium-20"
            >
              {t('cart.label.remove')}
            </MarketLink>
          )}
        </Grid>
      </Grid>
      {adjustmentItems}
    </>
  );
};

export default ActionablePromotion;
